/**
 * SeloTipo — selo "Especialista" / "Genérico" de um agente, com tooltip curto.
 *
 * O tipo vem do campo `tipo` da API (GET /agents, conferência); sem ele, a regra local
 * dos 7 papéis de camada sem tecnologia (`tipoDoAgente`, comum.js).
 *
 * Paleta C, estilos inline, pt-BR.
 */
import { C } from '@/theme/palette';
import { tipoDoAgente, TEXTO_DO_TIPO, TITULO_DO_TIPO } from './comum';

/**
 * @param {{ agente?: object|string, tipo?: 'especialista'|'generico', testId?: string }} props
 */
export function SeloTipo({ agente, tipo, testId }) {
  const t = tipo === 'especialista' || tipo === 'generico' ? tipo : tipoDoAgente(agente);
  const cor = t === 'generico' ? C.neutralMuted : C.cyber;
  return (
    <span
      data-testid={testId}
      data-tipo={t}
      title={TITULO_DO_TIPO[t]}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 3,
        fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 5,
        color: cor, background: `${cor}14`, border: `1px ${t === 'generico' ? 'dashed' : 'solid'} ${cor}55`,
        whiteSpace: 'nowrap', cursor: 'help',
      }}
    >
      {t === 'especialista' ? '⭐ ' : ''}{TEXTO_DO_TIPO[t]}
    </span>
  );
}
